module.exports = __webpack_public_path__ + "static/media/avatar-H_Q.ce7e6f18.png";